import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useContext } from 'react';
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../MenuHeader.styles";
/**
 * Заголовок в меню.
 */

function MenuHeader(_ref) {
  var _cx;

  var _ref$_enableIconPaddi = _ref._enableIconPadding,
      _enableIconPadding = _ref$_enableIconPaddi === void 0 ? false : _ref$_enableIconPaddi,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["_enableIconPadding", "children"]);

  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(CommonWrapper, rest, /*#__PURE__*/React.createElement("div", {
    className: cx((_cx = {}, _cx[styles.root(theme)] = true, _cx[styles.withLeftPadding(theme)] = _enableIconPadding, _cx))
  }, children));
}

MenuHeader.__KONTUR_REACT_UI__ = 'MenuHeader';
MenuHeader.__MENU_HEADER__ = true;
export { MenuHeader };
export var isMenuHeader = function isMenuHeader(child) {
  return /*#__PURE__*/React.isValidElement(child) ? Object.prototype.hasOwnProperty.call(child.type, '__MENU_HEADER__') : false;
};